module.exports = "https://cdn.ticketswap.com/_next/static/images/mobile-screen-smaller-e4bed51102ceb81061978ba55b4ed70e.jpg";